import React from 'react';
import { Chip } from '@mui/material';

const CustomizeChip = (props) => {
    const {
        label = "primary",
        color = 'primary',
        variant = 'filled',
        size,
        onDelete,
        onClick,
        sx = {},
    } = props;

    const isClickable = typeof onClick === 'function';

    // Remove any cursor override from passed-in sx
    const filteredSx = { ...sx };
    if (!isClickable && filteredSx.cursor) {
        delete filteredSx.cursor;
    }

    return (
        <Chip
            label={label}
            size={size}
            variant={variant}
            onClick={onClick}
            onDelete={onDelete}
            color={color}
            sx={{
                backgroundColor: variant === 'filled' ? color : 'transparent',
                color: variant === 'filled' ? '#fff' : color,
                border: variant === 'outlined' ? `1px solid ${color}` : 'none',
                fontWeight: 500,
                letterSpacing: 0.5,
                textTransform: 'capitalize',
                cursor: isClickable ? 'pointer' : 'default',
                ...filteredSx,
            }}
        />
    );
};

export default CustomizeChip;
